export const FETCH_SURVEY_DETAIL_BY_ID = 'FETCH_SURVEY_DETAIL_BY_ID';
export const TEST='TEST';
export const POST_SURVEY_DETAIL_BY_ID = 'POST_SURVEY_DETAIL_BY_ID';
export const FETCH_LANGUAGE_LIST = 'FETCH_LANGUAGE_LIST';

